export const NotFound404 =()=>{
  return(
    <div className="w-100 m_h-100vh bg-dark d-flex justify-content-center align-items-center text-white">
      <span className="fs-1">NOT FOUND 404</span>
    </div>
  )
}